<div style="display: flex; gap: 15px;align-items: baseline;">
    <mat-select-autocomplete
        [formControl] = "formControl"
        [options]="columnOptions"
        label="vis/skjul, kolonner">
    </mat-select-autocomplete>
    <!-- <button mat-raised-button color="primary" style="width: fit-content;" (click)="selectAllColumns()">Vælg alle</button>
    <button mat-raised-button color="primary" style="width: fit-content;" (click)="deselectAllColumns()">Fravælg alle</button> -->
</div>
